var scope_0 = require('/Users/ryanmulligan/Developer/gatsby/dotcom/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7afe4d60093d0fba0b736a0caecadbf2.js').default;
var scope_1 = require('/Users/ryanmulligan/Developer/gatsby/dotcom/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a12940b9fcb6bdafcd3a0aab26835459.js').default;
var scope_2 = require('/Users/ryanmulligan/Developer/gatsby/dotcom/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bb371b604cd58d6bdc41f05f30d23fb7.js').default;
var scope_3 = require('/Users/ryanmulligan/Developer/gatsby/dotcom/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c47f9718e4898d56e5f1cb0df631f1b5.js').default;
var scope_4 = require('/Users/ryanmulligan/Developer/gatsby/dotcom/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/dd531b7a7fa8a8f6c45fcf280e980a1a.js').default;
var scope_5 = require('/Users/ryanmulligan/Developer/gatsby/dotcom/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/eb52f6a499176f86af1880ddd3470904.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5 )
    